module.exports = __webpack_public_path__ + "static/img/rank_161.1edcf04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_161.png
// module id = TdWj
// module chunks = 1